import React, { useState } from "react";
import './OutsourcingFaqs.css';
import q from "../assets/images/faqs.png";

const OutsourcingFaqs = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const faqs = [
    {
      question: "What types of outsourcing services do you offer?",
      answer:
        "We offer comprehensive outsourcing services across three main categories: U.S. Accounting & Taxation Services, Indian Accounting & Taxation Services, and Digital Services. This includes everything from GST filing and TDS compliance in India to U.S. tax preparation and digital services like web development and content writing.",
    },
    {
      question: "How does your outsourcing process work?",
      answer:
        "Our process begins with a consultation to understand your specific needs. We then assign a dedicated team, establish communication protocols, and implement quality control measures. You'll receive regular updates and have access to our project management tools for complete transparency.",
    },
    {
      question: "What are your service level agreements (SLAs)?",
      answer:
        "Our SLAs vary by service but typically include guaranteed response times (within 24 hours), accuracy rates (98%+ for financial services), and turnaround times (e.g., 3-5 business days for standard tax filings). We customize SLAs based on client requirements.",
    },
    {
      question: "How do you ensure data security with outsourced services?",
      answer:
        "We implement enterprise-grade security including 256-bit encryption, two-factor authentication, secure file transfer protocols, and strict access controls. All team members sign comprehensive NDAs and undergo security training.",
    },
    {
      question: "Can you handle both Indian and U.S. compliance for my business?",
      answer:
        "Absolutely. We specialize in cross-border compliance and have teams experienced in both Indian and U.S. regulations. We can seamlessly handle requirements like GST filings in India alongside US tax preparation and payroll processing.",
    },
    {
      question: "What qualifications do your accounting professionals have?",
      answer:
        "Our team includes CAs, CPAs, EAs, and accounting graduates with specialized training. For U.S. services, our professionals average 5+ years of experience with IRS compliance. Indian services are handled by GST practitioners and tax professionals.",
    },
    {
      question: "How do you charge for outsourcing services?",
      answer:
        "We offer flexible pricing models: monthly retainers for ongoing services, fixed-fee packages for defined projects, and hourly rates for ad-hoc needs. Digital services often follow project-based pricing. Contact us for a customized quote.",
    },
    {
      question: "What technology platforms do you use?",
      answer:
        "We work with all major platforms including QuickBooks, Xero, Tally, Zoho Books, and custom solutions. For digital services, we use modern stacks like React, Node.js, and Python. We can integrate with your existing systems.",
    },
    {
      question: "How do you handle communication across time zones?",
      answer:
        "Our teams operate with overlapping shifts to ensure availability during your business hours. We provide dedicated account managers and use collaboration tools like Slack, Zoom, and Asana for seamless communication.",
    },
    {
      question: "Can I outsource just part of my accounting function?",
      answer:
        "Yes, we offer modular services. You might outsource just tax preparation while handling bookkeeping in-house, or delegate payroll while managing other HR functions. We'll customize a solution that fits your needs.",
    },
    {
      question: "What's your approach to quality control?",
      answer:
        "Every deliverable undergoes a three-tier review process: preparation by specialists, verification by senior team members, and final approval by department heads. We maintain detailed audit trails for all work.",
    },
    {
      question: "How quickly can you onboard our account?",
      answer:
        "Standard onboarding takes 3-5 business days after receiving necessary documents. For urgent needs, we offer expedited 48-hour onboarding with priority document processing.",
    },
    {
      question: "Do you provide references from current clients?",
      answer:
        "Yes, we can provide anonymized case studies and, with their permission, connect you with clients in similar industries to discuss their experiences with our outsourcing services.",
    },
    {
      question: "What makes your outsourcing different from competitors?",
      answer:
        "Our unique value comes from: 1) Dual expertise in Indian and U.S. regulations, 2) Fixed-price options eliminating billing surprises, 3) Dedicated account managers, and 4) Technology-driven transparency with client portals.",
    },
    {
      question: "How do you stay updated on changing regulations?",
      answer:
        "We invest heavily in continuous education, with weekly training sessions, subscriptions to regulatory updates, and memberships in professional organizations like the AICPA and ICAI.",
    },
    {
      question: "What industries do you specialize in?",
      answer:
        "We have particular expertise in e-commerce, professional services, technology startups, healthcare, and manufacturing. However, our services are adaptable to virtually any industry.",
    },
    {
      question: "Can you help with state-specific tax requirements in the U.S.?",
      answer:
        "Yes, our U.S. team has specialists familiar with all state tax jurisdictions. We handle sales tax nexus determinations, multi-state filings, and stay current on local tax law changes.",
    },
    {
      question: "Do you offer services for Indian startups?",
      answer:
        "Absolutely. We provide startup packages that include company registration, GST compliance, accounting setup, and investor-ready financial reporting - all tailored for Indian startups.",
    },
    {
      question: "What's your policy on errors and corrections?",
      answer:
        "We stand behind our work with a 100% accuracy guarantee. Any errors identified are corrected at no additional cost, with root cause analysis to prevent recurrence.",
    },
    {
      question: "How scalable are your services?",
      answer:
        "Our operations are designed to scale with your business. We can quickly ramp up support during peak seasons (like tax time) or as your business grows, without service interruptions.",
    },
    {
      question: "Can you integrate with our existing accounting software?",
      answer:
        "In most cases, yes. We're experienced with all major platforms and can either work within your system or recommend migration options if needed for better efficiency.",
    },
    {
      question: "What's your client retention rate?",
      answer:
        "We maintain a 92%+ annual client retention rate, with most long-term relationships spanning 3+ years. Our focus on consistent quality and responsive service drives this loyalty.",
    },
    {
      question: "Do you offer compliance calendar services?",
      answer:
        "Yes, we provide customized compliance calendars tracking all filing deadlines (GST, TDS, ROC, IRS) with automated reminders to ensure you never miss a due date.",
    },
    {
      question: "How do you handle sensitive financial data?",
      answer:
        "We use bank-grade security protocols including encrypted storage, secure file transfer, and strict access controls. Our facilities have 24/7 monitoring and we undergo regular security audits.",
    },
    {
      question: "What's your turnaround time for tax filings?",
      answer:
        "Standard tax filings are completed within 5 business days of receiving complete documentation. Urgent filings (48-hour turnaround) are available for an additional fee.",
    },
  ];

  return (
    <div className="outsourcing-faqs-container">
      <div className="outsourcing-faqs-header">
        <h2 className="outsourcing-faqs-heading">Outsourcing Questions?</h2>
        <h3 className="outsourcing-faqs-subheading">Everything you need to know about our outsourcing services.</h3>
        <img 
          src={q} 
          alt="Outsourcing Services at Krinvy"
          className="outsourcing-faqs-image" 
        />
      </div>

      <div className="outsourcing-faqs-accordion">
        {faqs.map((faq, index) => (
          <div 
            key={index} 
            className={`outsourcing-faqs-item ${activeIndex === index ? 'active' : ''}`}
          >
            <button 
              className="outsourcing-faqs-question"
              onClick={() => toggleAccordion(index)}
              aria-expanded={activeIndex === index}
            >
              <h3>{faq.question}</h3>
              <span className="outsourcing-faqs-icon">
                {activeIndex === index ? '−' : '+'}
              </span>
            </button>
            <div className="outsourcing-faqs-answer">
              <p>{faq.answer}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default OutsourcingFaqs;